import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=74b5d333"
import script from "./NotFound404.vue?vue&type=script&lang=js"
export * from "./NotFound404.vue?vue&type=script&lang=js"
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=74b5d333&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports